import { Reveal, SectionHeading } from "@/components/motion";

const PHASES = [
  {
    q: "Q1",
    title: "Truth Engine MVP",
    status: "SHIPPED",
    items: ["Event ingestion & verification", "Distance and time deltas", "Telemetry consistency scoring"],
  },
  {
    q: "Q2",
    title: "Compliance Engine",
    status: "SHIPPED",
    items: ["Geofence validation", "Arrival window enforcement", "Proximity & evidence rules"],
  },
  {
    q: "Q3",
    title: "Anomaly Detection",
    status: "SHIPPED",
    items: ["Spoofing signatures", "Impossible-travel detection", "Severity scoring & actions"],
  },
  {
    q: "Q4",
    title: "Insurance Audit Integrations",
    status: "IN PROGRESS",
    items: ["Signed audit export packets", "Insurer API bridge", "Claims reconciliation feeds"],
  },
];

const StatusChip = ({ status }) => {
  const cls =
    status === "SHIPPED"
      ? "bg-truth text-white"
      : status === "IN PROGRESS"
        ? "bg-telemetry text-white"
        : "border border-border text-muted-foreground";
  return (
    <span className={`font-mono text-[10px] tracking-[0.2em] px-2.5 py-1 ${cls}`}>{status}</span>
  );
};

const Roadmap = () => (
  <section id="roadmap" data-testid="roadmap" className="border-b border-border">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <SectionHeading index="09" eyebrow="Roadmap" title="Where the truth layer goes next." />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
        {PHASES.map((p, i) => (
          <Reveal key={p.q} delay={i * 0.07} className="border-b border-r border-border">
            <div data-testid={`roadmap-${p.q.toLowerCase()}`} className="h-full p-8 lg:p-10 flex flex-col group hover:bg-muted/50 transition-colors duration-200">
              <div className="flex items-center justify-between">
                <span className="font-display font-black tracking-tight text-5xl text-foreground/15 group-hover:text-telemetry transition-colors duration-500">
                  {p.q}
                </span>
                <StatusChip status={p.status} />
              </div>
              <h3 className="font-display font-extrabold tracking-tight text-2xl mt-8">{p.title}</h3>
              <ul className="mt-5 space-y-2.5 flex-1">
                {p.items.map((item) => (
                  <li key={item} className="text-sm text-muted-foreground flex gap-3">
                    <span className="font-mono text-telemetry mt-0.5">—</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Roadmap;
